import { t } from '@lingui/macro';
import { useParams } from 'react-router-dom';
import ContentWrapper from '../../../components/Layouts/ContentWrapper';
import PaymentForm from '../../BookingInfo/PaymentForm';

export const TireOfferConfirmationWithPaymentLeft = () => {
  const { sessionId } = useParams() as { sessionId: string };

  return (
    <ContentWrapper title={t`How would you like to pay?`} hideBackButton>
      <PaymentForm sessionId={sessionId} countryCode='NO' />
    </ContentWrapper>
  );
};
